'use strict';

wbApp.controller('MyCoursesCtrl', ['$scope', '$http', '$q', '$translate', '$modal', '$timeout', '$window', 'notificationSvc', 'tenantSettingSvc', 'urlUtils',
function ($scope, $http, $q, $translate, $modal, $timeout, $window, notificationSvc, tenantSettingSvc, urlUtils) {

    $scope.showArrearInMyCourses = tenantSettingSvc.settings.showArrearInMyCourses;
    $scope.disableExcuseInMyCourses = tenantSettingSvc.settings.disableExcuseInMyCourses;

    $scope.contentInfos = [];

    $scope.tabs = [
        {
            title: 'TXT_TAB_COURSE_SELECTION',
            template: 'my-courses/course-selection-tab.html'
        },
        {
            title: 'TXT_TAB_ATTENDANCE',
            template: 'my-courses/attendance-detail-tab.html'
        }];

    $scope.tabs.activeTab = 0;


    $scope.$watch('tabs.activeTab', function (newValue, oldValue) {
        if (newValue == 0) {
            urlUtils.setUrlParam("studentID", null);
            urlUtils.setUrlParam("courseID", null);
        } else if (!!$scope.selectedCourse && !!$scope.selectedStudent) {
            urlUtils.setUrlParam("studentID", $scope.selectedStudent.studentID);
            urlUtils.setUrlParam("courseID", $scope.selectedCourse.courseID);
        }
    });

    $scope.students = myCourses;

    $scope.selectedStudentID = urlUtils.getQueryParams()['studentID'];
    $scope.selectedCourseID = urlUtils.getQueryParams()['courseID'];

    function extendModel(students) {
        for (var s = 0; s < students.length; s++) {
            var student = students[s];            
            for (var c = 0; c < student.courses.length; c++) {
                var course = student.courses[c];
                course.isOld = (moment(course.endDate).isBefore(moment().subtract(1, 'w')) && !course.seasonTicket) || moment(course.endDate).isBefore(moment().subtract(20, 'w'));
                student.hasOld |= course.isOld;
                student.hasNew |= !course.isOld;
            }
        }
    }

    function setUpCorrespondingSelectedCourse(students) {
        for (var s = 0; s < students.length; s++) {
            var student = students[s];
            if ($scope.selectedStudent && student.studentID === $scope.selectedStudent.studentID) {
                $scope.selectedStudent = student;
                for (var c = 0; c < student.courses.length; c++) {
                    var course = student.courses[c];
                    if ($scope.selectedCourse && course.courseID === $scope.selectedCourse.courseID) {
                        $scope.selectedCourse = course;
                        return;
                    }
                }
            }
        }
    }

    var myTimeout = null;
    $scope.onlineStartDate = null;
    $scope.onlineEndDate = null;
    var onlineEnabledThreshold = 1;

    $scope.startOnlineMeetingDisabled = true;

    $scope.onTimeout = function () {
        var ms = moment($scope.onlineStartDate).subtract('h', onlineEnabledThreshold).diff(moment());
        if (ms > 0) {
            $scope.startOnlineMeetingDisabled = true;
            var d = moment.duration(ms);
            $scope.onlineEnabledIn = Math.floor(d.asHours()) + moment.utc(ms).format(":mm:ss");

            myTimeout = $timeout($scope.onTimeout, 1000);
        } else {
            $timeout.cancel(myTimeout);
            if (moment($scope.onlineEndDate).isAfter(moment())) {
                $scope.startOnlineMeetingDisabled = false;
            } else {
                // Start over again with next closest lesson
                $scope.startOnlineMeetingDisabled = true;
                $scope.extendAttendanceModel($scope.attendance);
            }
        }
    }

    $scope.extendAttendanceModel = function(attendance) {
      //  if ($scope.selectedCourse.isOnlineMeeting) {

            var lastInThePastIdx = _.findLastIndex(attendance, function (o) { return moment(o.endDate).isBefore(moment().subtract(1, 'h')) });
            if (attendance.length > (lastInThePastIdx + 1)) {

                var index = -1;
                for (var i = lastInThePastIdx + 1; i < attendance.length; i++) {
                    var att = attendance[i];
                    if (att.courseAttendanceStatusID === 0 && att.isOnline) {
                        index = i;
                        break;
                    }
                }

                if (index === -1) {
                    return;
                }

                angular.forEach(attendance, function (att, idx) {
                    att.closestLesson = idx === index;
                });

                if (!!myTimeout) {
                    $timeout.cancel(myTimeout);
                }

                $scope.onlineStartDate = attendance[index].startDate;
                $scope.onlineEndDate = attendance[index].endDate;
                $scope.onTimeout();
            }
       // }
    }

    $scope.setSelectedCourse = function (student, course) {
        $scope.selectedCourse = course;
        $scope.selectedStudent = student;
        $scope.tabs.activeTab = 1;

        urlUtils.setUrlParam("studentID", student.studentID);
        urlUtils.setUrlParam("courseID", course.courseID);

        $q.all([
            getAttendanceDetail(student.studentID, course.courseID),
            getAccessibleContentInfos(student.studentID, course.courseID)]).then(
            function (data) {
                $scope.attendance = data[0].data;
                $scope.contentInfos = data[1].data;
                $scope.extendAttendanceModel($scope.attendance);
            });
    }

    if ($scope.students.length) {
        extendModel($scope.students);

        if (!!$scope.selectedStudentID && !!$scope.selectedCourseID)
        {
            $scope.selectedStudent = _.find($scope.students, function (s) { return s.studentID == $scope.selectedStudentID; });
            if (!!$scope.selectedStudent) {
                $scope.selectedCourse = _.find($scope.selectedStudent.courses, function (c) { return c.courseID == $scope.selectedCourseID; });
            }
            if (!$scope.selectedCourse) {
                $scope.selectedStudent = null;

                urlUtils.setUrlParam("studentID", null);
                urlUtils.setUrlParam("courseID", null);

                if ($scope.students[0].courses.length) {
                    $scope.selectedStudent = $scope.students[0];
                    $scope.selectedCourse = $scope.students[0].courses[0];

                    $q.all([
                        getAttendanceDetail($scope.selectedStudent.studentID, $scope.selectedCourse.courseID),
                        getAccessibleContentInfos($scope.selectedStudent.studentID, $scope.selectedCourse.courseID)]).then(
                        function (data) {
                            $scope.attendance = data[0].data;
                            $scope.contentInfos = data[1].data;
                            $scope.extendAttendanceModel($scope.attendance);
                        });
                }
            }
            else
            {                
                $scope.setSelectedCourse($scope.selectedStudent, $scope.selectedCourse);
            }
        } else {
            if ($scope.students[0].courses.length) {
                $scope.selectedStudent = $scope.students[0];
                $scope.selectedCourse = $scope.students[0].courses[0];

                $q.all([
                    getAttendanceDetail($scope.selectedStudent.studentID, $scope.selectedCourse.courseID),
                    getAccessibleContentInfos($scope.selectedStudent.studentID, $scope.selectedCourse.courseID)]).then(
                    function (data) {
                        $scope.attendance = data[0].data;
                        $scope.contentInfos = data[1].data;
                        $scope.extendAttendanceModel($scope.attendance);
                    });
            }
        }
    }

    $scope.switchMe = function (idx) {
        $scope.tabs.activeTab = idx;
    }

    $scope.onPrevBtnClick = function () {
        $scope.tabs.activeTab = 0;
    }

    $scope.onNextBtnClick = function () {
        $scope.tabs.activeTab = 1;
    }

    $scope.onAttendanceChangeClick = function (at, course) {
        $http({
            method: 'POST',
            url: '/MyCourses/ChangeStudentAttendance',
            params: { StudentID: at.studentID, CourseScheduleID: at.courseScheduleID, CourseID : course.courseID }
        })
        .success(function (data, status, headers, config) {
            $scope.attendance = data.attendance;
            $scope.extendAttendanceModel($scope.attendance);
            $scope.students = data.students;
            extendModel($scope.students);
            setUpCorrespondingSelectedCourse($scope.students);
            notificationSvc.notifyInfo(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_SUCCESS'));
        })
        .error(function (data, status, headers, config) {
            notificationSvc.notifyError(
                $translate.instant('TXT_ALERT_ATTENDANCE_SAVE_FAILURE'),
                notificationSvc.translateError(data));
        });
    }

    $scope.modal = { title: "", saved: false };

    var modalPromise = $modal({
        templateUrl: 'my-courses/attendance-change-detail.html',
        show: false,
        backdrop: true,
        scope: $scope
    });

    $scope.onClickMe = function (student, course, at) {

        if (tenantSettingSvc.settings.disableExcuseInMyCourses) {
            return;
        }

        $scope.modal.title = getAttendanceOperationTitle(at);
        $scope.modal.description = getAttendanceOperationDescription(student, at);
        $scope.modal.attendance = at;
        $scope.modal.course = course;

        modalPromise.$promise.then(function () {
            modalPromise.show();
        });
    }

    function getAttendanceOperationTitle (at) {
        if (at.courseAttendanceStatusID === 0) { // Present
            return $translate.instant("TXT_EXCUSE_ACTION");
        } else {
            if (at.operationPendingInWaitingQueue) {
                return $translate.instant("TXT_EXCUSE_ACTION");
            } else {
                return $translate.instant("TXT_EXCUSE_CANCEL_ACTION");
            }
        }
    }

    function getAttendanceOperationDescription(student, at) {
        if (at.courseAttendanceStatusID === 0) { // Present
            return $translate.instant("TXT_EXCUSE_ACTION_DESC")
                .f(student.studentFullName, at.schedule, at.courseFullName);
        } else {
            if (at.operationPendingInWaitingQueue) {
                return $translate.instant("TXT_EXCUSE_CANCEL_ACTION_W_DESC")
                    .f(student.studentFullName, at.schedule, at.courseFullName);
            } else {
                return $translate.instant("TXT_EXCUSE_CANCEL_ACTION_DESC")
                    .f(student.studentFullName, at.schedule, at.courseFullName);
            }
        }
    }

    function getAccessibleContentInfos(studentID, courseID)
    {
        return $http({
            method: 'GET',
            url: '/Api/CourseRegistrations/GetAccessibleContentInfos',
            params: { StudentID: studentID, CourseID: courseID }
        });
    }

    function downloadDataUrlFromJavascript(name, dataUrl) {
        var link = document.createElement("a");
        link.target = "_blank";
        link.setAttribute("download", name);
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    $scope.onContentInfoClick = function (contentInfo)
    {
        if (contentInfo.accessType == 1)
        {
            // get download url and initiate download
            $http({
                method: 'POST',
                url: '/Api/CourseRegistrations/GetContentInfoDownloadUrl',
                params: { StudentID: $scope.selectedStudent.studentID, CourseID: $scope.selectedCourse.courseID },
                data: contentInfo
            }).then(function (payload) {
                downloadDataUrlFromJavascript(contentInfo.name, payload.data.url);
            });
        }
        else
        {
            window.open(
                "/MediaPlayer?studentID=" + 
                $scope.selectedStudent.studentID +
                "&courseID=" +
                $scope.selectedCourse.courseID +
                "&objectUri=" + encodeURI(contentInfo.objectUri), 
                "_blank", 
                "width=1024,height=768,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no");
        }
    }


    function getAttendanceDetail(studentID, courseID) {
        return $http({
            method: 'GET',
            url: '/MyCourses/StudentCourseAttendance',
            params: { StudentID: studentID, CourseID: courseID }
        });
    }

    $scope.onStudentExpanded = function (student) {
        student.expanded = !student.expanded;
    }

    $scope.onPrintInvoice = function (courseRegistrationID) {
        $window.open('/Admin/Report/Invoice?ReportID=' + courseRegistrationID + '&ReportIDType=0',
            '_blank', 'width=1000,height=500,toolbar=no,resizable=yes,location=no,directories=no,status=no,menubar=no,copyhistory=no');
    }

}]);
